<script>

    import { createEventDispatcher } from 'svelte'

    export let input = null

    export let label = null
    export let icon = null
    export let iconRight = null
    export let value = null
    export let placeholder = null
    export let iconType = 'fa'
    export let maxlength = null
    export let minlength = null
    export let required = true
    export let readonly = false
    export let fullwidth = true
    export let loading = false

    const dispatch = createEventDispatcher()

    function onKeyup(event) {
        if(event.code === 'Enter')
            dispatch('enter')
    }

</script>

<div class="field">
    {#if label}
        <label for="" class="label">{ label }</label>
    {/if}
    <p class="control" class:is-loading={loading} class:has-icons-left={icon} class:has-icons-right={iconRight}>
        {#if icon}
            <span class="icon is-left"><i class="fas { iconType }-{ icon }"></i></span>
        {/if}
        <input bind:this={input} on:change on:blur on:focus on:keyup={onKeyup} on:keyup bind:value={ value } class="input" type="text" class:is-fullwidth={fullwidth} { readonly } { maxlength } { minlength } { placeholder } { required } >
        {#if iconRight}
            <span class="icon is-right"><i class="fas { iconType }-{ iconRight }"></i></span>
        {/if}
    </p>
</div>